<template>
	<div id="app">
		<router-view />
	</div>
</template>
<script>
	// import devicePixelRatio from '@/js/devicePixelRatio.js'
	export default {
		mounted() {
			// this.checkIsIframe()
			// this.resizeFun()
		},
		methods: {
			
			
			// 检测防止网页被iframe、web-view嵌入
			checkIsIframe(){
				if (window.top !== window.self) {
				    // 如果检测到被嵌入到iframe中
				    // 可以选择跳转到当前页，或显示提示信息
				    window.top.location = window.self.location;
				    // 或者：
					// document.body.innerHTML = '此页面不允许被嵌入';
				}
			},
			
			// 设计稿根据 1920*1080 100% 
			// 根据用户屏幕的分辨率，比如现在分辨率为1.25，那对.el_container和.el_header进行补偿，原本100vw需要改成125vw
			// bug1 : 使用zoon缩放之后，会对组件下面的弹出框会进行偏移，原因是元素定位还是zoom缩放前的位置。
			// bug2 : 部分页面高度、字体大小并没有根据这个方法进行适配
			resizeFun() {
				const devicePixelRatio = window.devicePixelRatio;
				console.log('设备像素比:', devicePixelRatio);
				if(devicePixelRatio > 2){
					return
				}
				if (devicePixelRatio > 1) {
					// 修正计算：缩放比例应该是1/devicePixelRatio，补偿系数就是devicePixelRatio
					const scale = 1 / devicePixelRatio; // 缩放比例 ：1.25 -> 0.8 (80%)
					const compensation = devicePixelRatio; // 补偿系数 ：1.25 -> 1.25
					
					// 应用缩放，将页面缩放到100%显示效果
					document.body.style.zoom = scale;
					
					// 对容器进行尺寸补偿
					this.compensateContainerSize(compensation);
					
					console.log(`缩放比例: ${(scale * 100).toFixed(0)}%, 补偿系数: ${compensation}`);
				}
			},
			compensateContainerSize(compensation) {
				// 动态添加补偿样式
				const style = document.createElement('style');
				style.id = 'dpi-compensation-style'; // 添加ID便于管理
				// 
				style.textContent = `
				    /* 部分容器补偿 */
					.el_container {
						width: ${100 * compensation}vw !important;
						height: ${100 * compensation}vh !important;
						transform-origin: 0 0;
					}
					.el_header {
						width: ${100 * compensation}vw !important;
					}
					#cesiumContainer{
						width: ${100 * compensation}vw !important;
						height: ${100 * compensation}vh !important;
					}
					.transparentContainer{
						width: ${100 * compensation}vw !important;
						height: ${100 * compensation}vh !important;
					}
				`;
				// 移除旧的样式（如果存在）
				const oldStyle = document.getElementById('dpi-compensation-style');
				if (oldStyle) {
					document.head.removeChild(oldStyle);
				}
				
				document.head.appendChild(style);
			}
		}
	};
</script>
<style>
	* {
		margin: 0px;
		padding: 0px;
		transition: background-color 0.3s ease, color 0.3s ease, border-color 0.3s ease;
	}
	::-webkit-scrollbar {
	    display: none; 
	}

	/* 基础样式 */
	.el_container{
		width: 100vw;
		height: 100vh;
		background-color: var(--color-bg-el_container);
	}
	.el_header {
	  background-color: var(--color-bg-el_hear);
	  text-align: center;
	  line-height: 60px;
	}
	
	/* 其他样式保持不变 */
	.el-menu.el-menu--popup.el-menu--popup-right-start {
		background-color: var(--color-bg-el-menu--popup-right-start) !important;
	}
	.Line{
	    width:100%;
	    height:2px;
	    background: linear-gradient(297deg, var(--color-line-left), var(--color-line-center) 51%, var(--color-line-right));
	}
	.Line-column{
	    width:2px;
	    height:100%;
	    background: linear-gradient(297deg, var(--color-line-left), var(--color-line-center) 51%, var(--color-line-right));
	}
	.el-empty{
	    padding: 10px 0 !important;
	}
</style>